import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { SearchDialogAnalyticsContext, useAnalytics } from '../../common/analytics';
import { onExperimentLoaded } from '../../common/analytics/events';
import { PLACEHOLDER_EXPERIENCE, useAggregatorClient } from '../aggregator-client-context';
import { useProductContext } from '../product-router/product-router';
import { useExperiments } from '../../common/experiment-provider';
import { PERFORMANCE_IMPROVEMENT_DUMMY_SECTION } from '../product-router/product/check-product-permissions';
export var DEFAULT_AB_TEST = {
  abTestId: 'default',
  controlId: 'default',
  experimentId: 'default'
};
var ABTestContext = /*#__PURE__*/React.createContext({
  abTest: null
});
var ABTestContextProviderStateless = function ABTestContextProviderStateless(_ref) {
  var isMultiProduct = _ref.isMultiProduct,
    searchClient = _ref.searchClient,
    scope = _ref.scope,
    children = _ref.children,
    primaryProductId = _ref.primaryProductId,
    experience = _ref.experience;
  var _useExperiments = useExperiments(),
    backendExperiment = _useExperiments.backendExperiment,
    _useExperiments$front = _useExperiments.frontendExperiments,
    frontendExperiments = _useExperiments$front === void 0 ? {} : _useExperiments$front;
  var _useState = useState(backendExperiment || null),
    _useState2 = _slicedToArray(_useState, 2),
    abTest = _useState2[0],
    setAbTest = _useState2[1];
  var _useAnalytics = useAnalytics(),
    fireAnalyticsEvent = _useAnalytics.fireAnalyticsEvent;
  useEffect(function () {
    var now = Date.now();
    if (!searchClient || !scope || abTest) {
      return;
    }
    if (scope === PERFORMANCE_IMPROVEMENT_DUMMY_SECTION) {
      setAbTest(DEFAULT_AB_TEST);
      return;
    }
    searchClient
    // TODO: Remove PLACEHOLDER_EXPERIENCE
    .getAbTestData(scope, experience !== null && experience !== void 0 ? experience : PLACEHOLDER_EXPERIENCE, primaryProductId).then(function (abTestResponse) {
      var duration = Date.now() - now;
      var abTestWithDefault = abTestResponse || DEFAULT_AB_TEST;
      setAbTest(abTestWithDefault);
      fireAnalyticsEvent(onExperimentLoaded(abTestWithDefault, duration, !!isMultiProduct));
    }).catch(function (e) {
      setAbTest(DEFAULT_AB_TEST);
    });
  }, [searchClient, fireAnalyticsEvent, isMultiProduct, scope, abTest, primaryProductId, experience, backendExperiment]);
  return /*#__PURE__*/React.createElement(ABTestContext.Provider, {
    value: {
      abTest: abTest
    }
  }, /*#__PURE__*/React.createElement(SearchDialogAnalyticsContext, {
    analyticContext: {
      abTest: abTest || undefined,
      frontendExperiments: _objectSpread({
        activeExperiments: Object.keys(frontendExperiments).filter(function (experiment) {
          var _frontendExperiments$;
          return (_frontendExperiments$ = frontendExperiments[experiment]) === null || _frontendExperiments$ === void 0 ? void 0 : _frontendExperiments$.serveExperiment;
        })
      }, frontendExperiments)
    },
    nonPrivacySafeAnalyticContext: {}
  }, children));
};
export var ABTestContextProvider = function ABTestContextProvider(props) {
  var _useProductContext = useProductContext(),
    getPrimaryProduct = _useProductContext.getPrimaryProduct;
  var searchClient = useAggregatorClient();
  var primaryProduct = getPrimaryProduct();
  var _ref2 = primaryProduct || {},
    sectionIds = _ref2.sectionIds;
  var scope = useMemo(function () {
    return sectionIds && sectionIds.length > 0 ? sectionIds[0] : undefined;
  }, [sectionIds]);
  return /*#__PURE__*/React.createElement(ABTestContextProviderStateless, _extends({}, props, {
    scope: scope,
    searchClient: searchClient,
    primaryProductId: primaryProduct === null || primaryProduct === void 0 ? void 0 : primaryProduct.id
  }));
};
export var useABTest = function useABTest() {
  var _useContext = useContext(ABTestContext),
    abTest = _useContext.abTest;
  return abTest;
};
export var withABTestContext = function withABTestContext(WrappedComponent) {
  return function (props) {
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, useContext(ABTestContext)));
  };
};